import { useEffect, useRef } from "react";
import { Modal, Button, Badge, type BadgeTone } from "@conuti-das/prince-ui";
import { Flex } from "@/ui-prince";
import { useLiveLog } from "@/hooks/useLiveLog";

const STATE_TONE: Record<string, BadgeTone> = {
  success: "green",
  failed: "red",
  running: "orange",
};

export function LiveLogDrawer({
  jobId, open, onClose, title,
}: { jobId: string | null; open: boolean; onClose: () => void; title: string }) {
  const { lines, state, exitCode, done } = useLiveLog(open ? jobId : null);
  const preRef = useRef<HTMLPreElement>(null);
  useEffect(() => {
    if (preRef.current) preRef.current.scrollTop = preRef.current.scrollHeight;
  }, [lines]);

  return (
    <Modal
      isOpen={open}
      title={`Live-Log: ${title}`}
      onOpenChange={(isOpen) => { if (!isOpen) onClose(); }}
      className="prn-modal-stretch"
    >
      <Flex style={{ padding: "var(--s-2) var(--s-4)", justifyContent: "space-between" }}>
        <Badge tone={STATE_TONE[state] ?? "gray"}>
          {state}{exitCode !== null && ` (exit ${exitCode})`}
        </Badge>
        <span>{lines.length} Zeilen</span>
      </Flex>
      <pre ref={preRef} style={{
        height: "60vh", margin: 0, padding: "var(--s-3)",
        background: "#0f172a", color: "#cbd5e1", overflow: "auto",
        fontSize: "0.78rem", lineHeight: 1.4, fontFamily: "monospace",
      }}>
        {lines.map((l, i) => <div key={i}>{l.text}</div>)}
        {!done && <div style={{ opacity: 0.6 }}>⋯ live</div>}
      </pre>
      <Flex justifyContent="End" style={{ marginTop: "var(--s-2)" }}>
        <Button variant="tinted" onPress={onClose}>Schließen</Button>
      </Flex>
    </Modal>
  );
}
